import styled from 'styled-components';
import { ControlButton } from 'ui/components/ControlButton/ControlButton';

export const ControlsContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const LeaveRoomButton = styled(ControlButton)`
    padding-left: 8px;
    padding-right: 8px;
`;

export const LockedControlWrapper = styled.span`
    display: inline-flex;
    align-items: center;
    opacity: 0.3;
    cursor: not-allowed;

    /* Блокируем клики по кнопкам/меню, hover остаётся на обёртке — для Tooltip на всю группу. */
    & * {
        pointer-events: none;
    }
`;

export const HiddenOnMobilePanel = styled.div`
    &:empty {
        margin-left: -2px;
        margin-right: -2px;
    }

    @media screen and (max-width: 991px) {
        display: none;
    }
`;
